// BEGIN::Added.by.KWShin.2024.02.29.
import { VUE_INSTANCE_NAME } from '../constants';
// FINISH::Added.by.KWShin.2024.02.29.

export function comma(value, ignoreZero = false) {
  return value === undefined || (ignoreZero && value == 0) ? '' : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// BEGIN::Added.by.KWShin.2023.07.08.
/**
 * microsecond를 m s ms 문자열로 바꾸어주는 함수
 */
export function mis2Msms(micros) {
  return ms2Msms(Math.floor(micros / 1000));
}
/**
 * millisecond를 m s ms 문자열로 바꾸어주는 함수
 */
export function ms2Msms(millis) {
  const vue = window[VUE_INSTANCE_NAME];
  if (millis < 1000) {
    return `${millis} ms`;
  } else if (millis < 60 * 1000) {
    let s = Math.floor(millis / 1000);
    let ms = Math.round(millis - s * 1000);
    let fms = ms < 10 ? '00' + ms : ms < 100 ? '0' + ms : ms;
    return `${s} ${vue.$t('common.term.second')} ${fms} ${vue.$t('common.term.millisecond')}`;
  } else {
    let m = Math.floor(millis / (60 * 1000));
    let s = Math.floor((millis - m * 60 * 1000) / 1000);
    let fs = s < 10 ? '0' + s : s;
    let ms = millis - (m * 60 * 1000 + s * 1000);
    let fms = ms < 10 ? '00' + ms : ms < 100 ? '0' + ms : ms;
    return `${m} ${vue.$t('common.term.minute')} ${fs} ${vue.$t('common.term.second')} ${fms} ${vue.$t('common.term.millisecond')}`;
  }
}
// FINISH::Added.by.KWShin.2023.07.08.

// BEGIN::Added.by.KWShin.2024.02.29.
/**
 * MilliSeconds를 시/분/초 문자열로 바꾸어주는 함수
 */
export function ms2Hms(msecs) {
  return s2Hms(Math.floor(msecs / 1000));
}
/**
 * Seconds를 시/분/초 문자열로 바꾸어주는 함수
 */
export function s2Hms(secs) {
  const vue = window[VUE_INSTANCE_NAME];
  if (secs < 60) {
    return `${secs} ${vue.$t('common.term.second')}`;
  } else if (secs < 60 * 60) {
    let m = Math.floor(secs / 60);
    let s = secs - m * 60;
    let fs = s < 10 ? '0' + s : s;
    let rtn = `${m} ${vue.$t('common.term.minute')}`;
    if (s > 0) rtn += `${fs} ${vue.$t('common.term.second')}`;
    return rtn;
  } else {
    let h = Math.floor(secs / (60 * 60));
    let m = Math.floor((secs - h * 60 * 60) / 60);
    let fm = m < 10 ? '0' + m : m;
    let s = secs - (h * 60 * 60 + m * 60);
    let fs = s < 10 ? '0' + s : s;
    let rtn = `${h} ${vue.$t('common.term.hour')}`;
    if (m > 0) rtn += `${fm} ${vue.$t('common.term.minute')}`;
    if (s > 0) rtn += `${fs} ${vue.$t('common.term.second')}`;
    return rtn;
  }
}
// FINISH::Added.by.KWShin.2024.02.29.

export function bytes(value, devider = 1024) {
  if (value === undefined || value === '') return '0 B';
  if (value < devider) return `${value} B`;
  let idx = 0;
  let devided = (value / devider).toFixed(1);
  while (devided > devider) {
    devided = (devided / devider).toFixed(1);
    idx++;
  }
  const unit = 'KMGTPEZY'.substring(idx, idx + 1);
  return `${devided} ${unit}B`;
}

export function kilobytes(value, devider = 1024) {
  if (value === undefined || value === '') return '0 B';
  if (value < devider) return `${value} KB`;
  let idx = 0;
  let devided = (value / devider).toFixed(1);
  while (devided > devider) {
    devided = (devided / devider).toFixed(1);
    idx++;
  }
  const unit = 'MGTPEZY'.substring(idx, idx + 1);
  return `${devided} ${unit}B`;
}

export function megabytes(value, devider = 1024) {
  if (value === undefined || value === '') return '0 B';
  if (value < devider) return `${value} MB`;
  let idx = 0;
  let devided = (value / devider).toFixed(1);
  while (devided > devider) {
    devided = (devided / devider).toFixed(1);
    idx++;
  }
  const unit = 'GTPEZY'.substring(idx, idx + 1);
  return `${devided} ${unit}B`;
}
